import { render, staticRenderFns } from "./SampleJGJ.vue?vue&type=template&id=f6fc70bc&scoped=true"
import script from "./SampleJGJ.vue?vue&type=script&lang=js"
export * from "./SampleJGJ.vue?vue&type=script&lang=js"
import style0 from "./SampleJGJ.vue?vue&type=style&index=0&id=f6fc70bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fc70bc",
  null
  
)

export default component.exports